export const fahrenheitToCelsius = (fahrenheitTemp: number): number =>
  (fahrenheitTemp - 32) / 1.8;
